import React from 'react';
import UiContent from '../../Components/Common/UiContent';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import BeachCleaningsList from './BeachCleaningsList';

const BeachCleaning = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Medio Ambiente', icon: 'icon-leaf' },
		{ to: '#', label: 'Limpieza de Playas', icon: 'icon-footprints' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Limpiezas Realizadas' links={breadcrumbLinks} icon={'icon-layout-list'} />
					<BeachCleaningsList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default BeachCleaning;